import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const getNewSubTaskTitles = () => {
  return api.get(URLS.subTaskTitles, {
    headers: {
      needsToken: true
    }
  });
};

export const getTaskListByOrderID = (orderID) => {
  return api.get(URLS.tasksList + `?id=${orderID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const addNewTask = (payload, orderID, mainTaskId) => {
  return api.post(
    URLS.tasks + `?orderID=${orderID}${mainTaskId ? `&id=${mainTaskId}` : ''}`,
    payload,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateTask = (taskId, payload) => {
  return api.put(`${URLS.tasks}?id=${taskId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const getTaskByTaskId = (taskId) => {
  return api.get(`${URLS.task}?id=${taskId}`, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteTaskByTaskId = (taskId, feModifiedTime) => {
  return api.delete(URLS.tasks, {
    params: {
      id: taskId,
      feModifiedTime: feModifiedTime
    },
    headers: {
      needsToken: true
    }
  });
};

export const taskSendComment = (taskId, payload) => {
  return api.post(URLS.comments + `?id=${taskId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const getCommentByTaskId = (taskId) => {
  return api.get(URLS.comments + `?id=${taskId}`, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteCommentByCommentId = (commentId, taskID) => {
  return api.delete(`${URLS.comments}?id=${commentId}&taskID=${taskID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updateCommentByCommentId = (commentId, taskID, payload) => {
  return api.put(`${URLS.comments}?id=${commentId}&taskID=${taskID}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const getTaskMembersList = (teamID, taskID, searchQuery, orderID) => {
  return api.get(URLS.taskMembers, {
    params: {
      teamID: teamID,
      taskID: taskID,
      ...(searchQuery && { query: searchQuery }),
      orderID: orderID
    },
    headers: {
      needsToken: true
    }
  });
};

export const searchTaskByOrderID = (orderID, searchQuery) => {
  return api.get(
    `${URLS.searchTask}?id=${orderID}${
      searchQuery ? `&query=${searchQuery}` : ''
    }`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};
